<template>
    <footer>
        <div class="us">
            <div class="title-logo-footer">
                <div class="logo" data-aos="fade-up" data-aos-duration="750">
                    <!DOCTYPE svg
                        PUBLIC "-//W3C//DTD SVG 20010904//EN" "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
                    <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="45pt" height="45pt"
                        viewBox="0 0 1024.000000 1024.000000" preserveAspectRatio="xMidYMid meet">
                        <metadata>
                            Created by potrace 1.16, written by Peter Selinger 2001-2019
                        </metadata>
                        <g transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)" stroke="none">
                            <path d="M3288 8770 c-24 -13 -47 -38 -69 -77 -32 -56 -33 -62 -37 -199 -3
                        -119 -1 -143 12 -157 9 -8 16 -18 16 -21 0 -7 -51 -58 -55 -54 -1 2 -10 17
                        -18 34 -30 59 -117 144 -181 175 -51 26 -70 30 -116 26 -49 -4 -58 -8 -91 -46
                        -24 -27 -40 -56 -44 -82 -8 -49 4 -217 16 -225 5 -3 9 -18 9 -33 0 -15 6 -36
                        14 -47 10 -13 11 -23 4 -31 -5 -6 -8 -24 -6 -40 3 -24 7 -28 35 -28 28 0 32
                        -4 39 -35 4 -19 6 -42 5 -51 -1 -9 9 -26 23 -37 l26 -20 -50 -21 c-27 -12 -53
                        -27 -57 -35 -4 -7 -21 -21 -38 -32 -52 -32 -221 -195 -317 -305 -113 -130
                        -238 -289 -238 -303 0 -3 -13 -20 -30 -38 -16 -18 -30 -38 -30 -44 0 -6 -11
                        -22 -23 -35 -13 -13 -37 -49 -53 -79 -16 -30 -32 -57 -36 -60 -13 -10 -128
                        -242 -140 -282 -6 -21 -15 -38 -19 -38 -4 0 -20 -37 -34 -82 -15 -46 -38 -106
                        -50 -133 -13 -28 -33 -91 -45 -140 -11 -50 -26 -98 -31 -108 -15 -28 -47 -191
                        -58 -302 -6 -55 -13 -120 -15 -145 -3 -25 -7 -67 -10 -95 -8 -81 -14 -293 -6
                        -260 4 19 8 -13 11 -85 3 -73 1 -118 -5 -122 -7 -5 -6 -18 2 -41 7 -18 12 -56
                        12 -83 0 -84 48 -388 69 -439 5 -11 16 -46 25 -77 9 -32 22 -58 29 -58 9 0 9
                        -2 0 -8 -8 -5 -6 -17 7 -45 10 -21 19 -41 20 -45 2 -4 6 -16 10 -27 4 -11 11
                        -35 15 -53 3 -17 11 -32 16 -32 6 0 7 -4 4 -10 -3 -5 10 -42 28 -82 19 -40 38
                        -84 42 -98 7 -24 68 -143 149 -293 20 -37 52 -90 71 -117 19 -27 35 -54 35
                        -58 0 -5 9 -17 21 -28 12 -10 30 -36 40 -57 11 -20 28 -43 39 -49 11 -7 20
                        -17 20 -22 0 -13 93 -111 102 -108 5 1 7 -4 5 -11 -3 -15 69 -23 86 -9 7 6 24
                        9 38 7 27 -3 37 20 13 29 -7 3 -40 46 -73 96 -34 50 -84 121 -112 158 l-52 67
                        34 6 c19 4 102 9 184 11 l150 3 -42 -145 c-48 -169 -55 -215 -33 -214 38 0
                        118 17 145 30 17 7 111 27 209 44 99 17 184 34 190 39 6 5 29 11 50 13 22 2
                        41 8 43 14 2 6 -36 46 -84 89 -94 84 -263 270 -263 290 0 6 -9 20 -20 30 -22
                        20 -118 161 -143 212 -9 17 -22 37 -29 45 -7 7 -26 42 -43 78 -16 36 -34 72
                        -40 80 -14 18 -55 115 -55 129 0 6 -11 34 -24 63 -13 29 -36 98 -52 153 -15
                        55 -30 105 -35 110 -14 19 -69 335 -69 397 0 20 -4 40 -10 43 -14 8 -14 442 0
                        450 6 3 10 25 10 49 0 55 56 342 75 381 7 17 23 68 35 115 12 47 28 94 34 105
                        7 11 28 61 46 110 19 50 37 92 42 95 4 3 15 23 24 45 9 21 36 69 60 107 24 37
                        44 71 44 76 0 4 10 19 23 32 12 13 31 38 42 56 109 173 468 509 630 589 84 42
                        113 31 84 -29 -24 -50 -25 -78 -1 -75 36 3 62 -1 62 -12 0 -6 -9 -13 -20 -16
                        -11 -3 -20 -12 -20 -19 0 -29 28 -80 64 -119 31 -32 34 -40 21 -47 -9 -5 -15
                        -22 -15 -41 0 -35 52 -135 75 -144 8 -3 29 -30 47 -62 17 -31 40 -67 50 -80
                        14 -18 15 -27 7 -38 -9 -10 -9 -20 1 -38 7 -14 17 -25 22 -25 4 0 8 -5 8 -11
                        0 -19 62 -139 71 -139 5 0 9 -6 9 -12 0 -11 41 -70 92 -135 7 -9 -11 -22 -64
                        -49 -72 -36 -135 -89 -183 -155 -30 -41 -85 -149 -85 -166 0 -7 -4 -13 -9 -13
                        -5 0 -24 -37 -41 -82 -17 -46 -37 -96 -45 -113 -21 -46 -53 -178 -61 -247 -4
                        -35 -10 -67 -14 -73 -4 -5 -11 -28 -15 -50 -13 -74 -56 -141 -162 -250 -49
                        -50 -53 -58 -53 -102 0 -43 5 -53 42 -91 41 -43 41 -43 25 -72 -21 -36 -21
                        -64 0 -100 16 -27 15 -29 -10 -60 -42 -50 -38 -105 13 -161 34 -39 39 -48 34
                        -80 -7 -40 16 -125 46 -174 31 -50 94 -102 137 -114 54 -15 87 -14 204 10 190
                        39 317 13 385 -77 44 -59 58 -138 51 -281 -6 -114 -7 -117 -39 -150 -18 -18
                        -60 -47 -95 -65 -35 -17 -63 -35 -63 -40 0 -4 -4 -8 -10 -8 -5 0 -51 -20 -102
                        -44 -51 -24 -122 -54 -158 -66 -36 -12 -76 -28 -90 -35 -14 -8 -63 -25 -110
                        -39 -47 -15 -97 -33 -112 -40 -15 -8 -42 -17 -60 -21 -52 -11 -211 -55 -233
                        -64 -11 -5 -80 -24 -154 -41 -74 -18 -142 -36 -150 -40 -9 -5 -65 -21 -126
                        -35 -137 -34 -172 -64 -96 -85 21 -5 56 -22 77 -37 22 -14 62 -37 91 -50 69
                        -32 80 -46 59 -78 -33 -51 -29 -54 149 -90 44 -9 85 -20 90 -25 6 -4 60 -20
                        120 -35 61 -15 119 -33 130 -40 11 -6 61 -25 110 -40 50 -16 115 -41 145 -57
                        30 -15 61 -28 69 -28 7 0 39 -13 70 -29 31 -16 114 -58 186 -92 71 -35 152
                        -78 179 -96 28 -18 55 -33 61 -33 5 0 23 -11 39 -25 16 -14 33 -25 37 -25 4 0
                        39 -24 77 -53 39 -28 83 -60 99 -69 15 -10 48 -33 73 -53 25 -19 72 -54 105
                        -77 33 -23 65 -47 70 -54 6 -6 28 -23 50 -37 22 -13 69 -52 104 -86 35 -33 69
                        -61 76 -61 8 0 14 30 18 98 10 152 33 257 79 352 80 164 249 349 396 430 23
                        13 42 27 42 30 0 4 36 21 80 39 44 19 80 37 80 41 0 4 39 20 88 35 48 15 105
                        36 127 45 22 10 117 30 210 45 94 15 175 31 180 35 9 7 86 14 485 40 187 13
                        312 28 325 41 5 5 17 9 27 9 27 0 219 58 235 71 17 14 17 39 0 39 -6 0 -28 -5
                        -47 -10 -24 -8 -77 -8 -175 0 -249 20 -458 42 -474 50 -9 4 -88 23 -176 40
                        -88 18 -164 36 -170 40 -5 3 -57 22 -115 41 -58 18 -107 37 -110 40 -3 3 -39
                        18 -80 34 -131 49 -255 107 -360 169 -41 25 -91 54 -111 65 -38 21 -128 94
                        -195 158 -23 21 -62 57 -87 81 -25 23 -66 75 -91 115 -37 60 -50 94 -71 188
                        -15 63 -30 122 -36 131 -5 10 -9 39 -9 64 0 44 1 46 18 32 12 -11 49 -17 119
                        -21 l102 -6 48 32 c64 43 78 74 78 172 0 70 -4 88 -33 147 -19 37 -38 70 -42
                        73 -10 6 24 102 45 125 26 30 130 244 140 289 4 17 10 31 15 31 8 0 40 84 62
                        160 6 25 16 48 21 51 10 7 18 41 47 182 24 118 26 219 5 278 -18 51 -74 112
                        -130 141 -22 11 -42 24 -45 29 -7 10 -188 69 -212 69 -9 0 -19 4 -23 9 -3 5
                        -19 12 -35 16 -17 4 -30 8 -30 11 0 2 16 26 35 53 19 27 40 63 46 80 6 17 15
                        31 20 31 9 0 59 103 59 122 0 5 9 29 20 54 22 48 70 225 70 259 0 12 4 25 9
                        31 8 8 41 147 41 173 0 6 -14 26 -30 45 -24 27 -27 35 -15 39 20 8 43 67 61
                        157 9 41 19 82 23 90 15 29 52 208 65 311 9 79 16 103 26 101 13 -3 139 -62
                        295 -137 39 -19 124 -59 190 -88 65 -30 120 -58 122 -63 2 -6 -3 -18 -10 -28
                        -12 -16 -17 -16 -82 15 -57 26 -76 30 -117 26 -56 -7 -57 -8 -161 -112 -121
                        -121 -125 -127 -139 -178 -11 -42 -10 -51 6 -80 15 -28 84 -92 125 -116 11 -7
                        10 -12 -4 -27 -26 -29 -104 -153 -128 -204 -11 -25 -26 -49 -33 -55 -7 -5 -25
                        -41 -40 -80 -14 -38 -29 -74 -34 -80 -4 -5 -20 -41 -35 -80 -15 -38 -36 -89
                        -46 -111 -10 -23 -21 -60 -25 -83 -6 -40 -6 -41 23 -41 29 0 31 3 48 68 10 37
                        31 92 45 122 15 30 36 80 46 110 10 30 24 60 29 66 6 6 24 42 40 80 16 38 36
                        76 43 84 8 8 20 26 26 40 6 14 29 53 51 87 33 51 45 63 67 63 14 0 39 10 55
                        23 15 12 51 33 78 47 28 13 64 35 81 47 17 13 35 23 40 23 5 0 39 31 74 68 36
                        37 80 74 98 81 18 8 42 27 54 43 18 26 22 28 30 14 5 -9 28 -28 51 -43 23 -14
                        48 -34 55 -45 7 -10 18 -18 23 -18 6 0 44 -27 84 -60 40 -33 76 -60 78 -60 9
                        0 93 -92 161 -175 101 -123 107 -131 130 -168 41 -66 81 -130 105 -166 13 -20
                        35 -63 47 -95 13 -33 30 -69 39 -82 8 -13 29 -65 46 -116 18 -51 35 -98 40
                        -103 4 -6 22 -73 39 -150 18 -77 36 -149 40 -160 16 -38 32 -181 37 -345 6
                        -166 -17 -490 -37 -535 -4 -11 -23 -81 -41 -155 -18 -74 -39 -151 -47 -170 -8
                        -19 -25 -70 -38 -113 -43 -142 -175 -403 -286 -565 -76 -110 -189 -242 -282
                        -331 -194 -183 -201 -190 -190 -201 11 -11 56 -19 224 -40 52 -6 104 -16 115
                        -21 28 -12 292 -38 405 -39 l95 -1 19 33 c11 18 26 37 33 41 7 5 24 23 36 41
                        12 18 56 78 97 133 41 56 83 114 92 129 10 16 36 58 59 94 59 93 168 307 175
                        347 3 18 10 33 14 33 10 0 26 41 50 135 12 44 28 95 36 113 8 18 12 36 9 42
                        -6 9 50 245 63 265 4 5 8 22 9 38 1 15 4 38 5 51 1 14 6 22 11 19 6 -3 8 10 5
                        30 -2 20 -1 38 3 39 4 2 13 66 20 143 20 236 -2 765 -38 880 -3 11 -8 29 -9
                        40 -8 48 -25 121 -31 135 -10 24 -54 190 -63 240 -15 79 -47 173 -81 240 -18
                        36 -34 72 -36 81 -4 24 -29 69 -36 63 -3 -3 -8 8 -12 25 -4 17 -10 31 -14 31
                        -4 0 -7 10 -8 22 -1 12 -18 44 -36 72 -19 28 -44 70 -56 94 -12 23 -25 42 -29
                        42 -5 0 -15 15 -24 33 -8 17 -36 60 -62 93 -25 34 -46 66 -46 72 0 6 -10 18
                        -21 26 -12 8 -30 29 -41 48 -11 18 -31 44 -44 58 -13 14 -45 50 -71 80 -66 76
                        -309 317 -362 360 -25 19 -54 44 -65 56 -12 11 -37 31 -56 44 -19 13 -42 30
                        -50 38 -28 26 -185 132 -196 132 -5 0 -19 8 -30 18 -11 11 -49 34 -84 53 -36
                        19 -67 37 -70 40 -8 11 -136 69 -151 69 -8 0 -34 11 -58 25 -23 14 -49 25 -56
                        25 -6 0 -34 11 -60 25 -26 15 -98 40 -159 56 -61 17 -120 34 -131 39 -35 16
                        -137 37 -260 55 -66 9 -127 20 -135 25 -9 4 -57 11 -107 15 l-92 7 -16 47 c-9
                        25 -29 61 -45 80 -25 29 -32 32 -45 21 -8 -7 -15 -25 -15 -41 0 -16 -4 -37 -9
                        -47 -5 -9 -12 -25 -15 -34 -5 -15 -18 -18 -91 -18 -47 0 -85 -4 -85 -8 0 -5
                        -53 -9 -117 -11 -65 -1 -167 -9 -227 -17 -60 -8 -114 -13 -121 -10 -8 3 -80
                        -4 -162 -15 -222 -30 -213 -27 -213 -49 0 -11 -4 -20 -10 -20 -13 0 -13 16 2
                        40 9 14 9 24 0 42 -6 13 -12 34 -14 48 -2 19 -9 25 -25 24 -17 0 -23 5 -23 21
                        0 77 -42 142 -84 131 -20 -5 -26 -1 -34 22 -13 37 -109 121 -163 143 -61 25
                        -163 24 -211 -1z m1372 -488 c0 -4 -11 -50 -24 -103 -30 -118 -48 -270 -50
                        -411 -1 -60 -4 -108 -8 -108 -5 0 -8 -24 -8 -54 0 -30 -4 -58 -10 -61 -5 -3
                        -10 -32 -11 -63 -1 -92 -15 -107 -22 -24 -9 97 -32 188 -51 208 -14 13 -15 29
                        -10 96 5 58 4 79 -4 74 -12 -7 -46 90 -36 106 3 5 2 17 -2 26 -4 9 -8 22 -10
                        29 -5 25 -45 72 -126 147 -76 70 -85 76 -125 76 -48 0 -47 1 -33 -35 8 -21 15
                        -25 33 -21 12 3 16 3 10 0 -7 -3 -13 -10 -13 -15 0 -14 28 -11 33 4 4 9 8 8
                        16 -3 5 -8 8 -16 7 -18 -2 -1 -34 -4 -70 -6 -65 -3 -66 -3 -42 13 17 11 22 21
                        17 31 -5 8 -11 27 -15 42 -6 25 -4 27 36 32 114 13 349 37 398 39 30 2 70 4
                        88 5 17 1 32 -1 32 -6z m620 -38 c178 -34 161 -22 159 -120 -2 -90 -10 -104
                        -58 -104 -19 0 -19 -2 -5 -36 8 -19 12 -45 8 -57 -5 -17 -9 -13 -25 27 -10 27
                        -20 50 -23 53 -11 11 -45 -20 -56 -52 -6 -19 -15 -35 -18 -35 -4 0 -14 24 -23
                        53 -42 135 -100 273 -121 291 l-23 19 30 -7 c17 -5 86 -19 155 -32z m829 -267
                        c107 -53 187 -97 177 -97 -23 0 -105 -42 -211 -110 -49 -32 -124 -75 -166 -98
                        l-75 -40 8 61 c4 34 16 114 27 177 11 63 23 137 26 163 4 27 9 47 13 45 4 -2
                        94 -47 201 -101z m-3164 -489 c24 -101 58 -218 75 -261 16 -43 30 -80 30 -82
                        0 -9 -38 11 -125 63 -138 84 -293 170 -312 174 -35 7 -21 28 74 109 131 112
                        193 175 193 196 1 42 22 -23 65 -199z m2039 193 c3 -5 22 -12 42 -15 19 -4 34
                        -10 32 -14 -15 -34 -132 -261 -134 -259 -1 1 2 40 6 87 5 47 9 113 9 148 1 54
                        3 62 20 62 11 0 22 -4 25 -9z m-1122 -138 c14 -39 25 -41 40 -8 6 14 17 25 23
                        25 7 0 23 10 36 23 30 27 104 61 117 53 10 -6 14 -51 38 -401 8 -121 18 -257
                        21 -302 3 -46 3 -83 0 -83 -4 0 -16 18 -27 40 -11 22 -24 40 -29 40 -10 0 -23
                        33 -46 125 -9 33 -24 78 -34 100 -10 22 -26 65 -36 95 -19 61 -91 216 -141
                        300 -17 30 -35 66 -38 80 -6 22 -2 20 29 -15 19 -22 40 -55 47 -72z m2910 -55
                        c75 -79 139 -146 142 -149 3 -3 -58 -32 -137 -64 -78 -32 -179 -75 -225 -96
                        l-83 -38 5 27 c3 15 8 47 11 72 4 25 18 89 31 143 27 106 32 162 20 190 -6 13
                        -4 17 10 17 11 0 30 9 44 20 14 11 30 20 35 20 6 0 72 -64 147 -142z m-4227
                        -120 c-3 -13 8 -68 25 -123 17 -55 44 -147 60 -205 16 -58 32 -113 35 -122 6
                        -16 0 -18 -56 -18 -67 0 -342 34 -371 45 -23 9 -12 30 56 111 28 33 96 122
                        151 197 55 75 101 136 103 137 1 0 0 -10 -3 -22z m4532 -206 c156 -188 253
                        -319 253 -339 0 -15 -13 -16 -60 -3 -37 10 -289 48 -377 57 -29 3 -53 9 -53
                        14 0 4 9 23 19 41 10 18 41 104 67 191 26 86 49 157 51 157 1 0 47 -53 100
                        -118z m-2226 -99 c-18 -63 -15 -73 22 -73 17 0 69 5 113 11 69 10 95 9 165 -5
                        46 -9 85 -19 88 -22 18 -17 -97 -60 -296 -109 l-153 -38 -9 -36 c-14 -54 -66
                        -278 -98 -426 l-28 -130 -6 55 c-14 130 -41 338 -57 436 l-17 107 -62 13 c-34
                        7 -108 31 -164 53 -63 26 -118 41 -148 42 -36 1 -41 3 -21 8 14 4 64 6 111 3
                        58 -3 88 -1 93 7 9 14 56 15 56 1 0 -5 11 -10 24 -10 14 0 28 5 31 10 3 6 1
                        10 -5 10 -6 0 -8 5 -4 11 4 7 39 9 109 4 130 -9 223 1 229 23 2 10 10 39 17
                        66 7 28 14 45 16 39 3 -7 0 -29 -6 -50z m-786 -160 c14 -16 22 -35 19 -43 -3
                        -8 -2 -11 2 -7 4 4 18 -18 32 -47 23 -52 25 -54 42 -38 16 15 16 25 8 85 -6
                        37 -8 70 -5 73 16 16 247 -48 247 -68 0 -10 -134 -72 -191 -90 -21 -6 -39 -17
                        -39 -24 0 -7 14 -80 30 -162 17 -83 30 -175 29 -204 -1 -74 -10 -47 -56 160
                        l-38 172 -28 0 c-16 0 -37 5 -48 10 -38 21 -86 14 -156 -22 -38 -20 -82 -38
                        -98 -42 -27 -5 -34 -1 -61 37 -18 23 -41 61 -53 84 l-21 42 44 26 c46 27 105
                        47 208 69 92 20 106 19 133 -11z m-1855 2 c0 -28 111 -330 150 -407 33 -66 36
                        -78 22 -79 -9 -1 -108 0 -219 1 -181 2 -203 0 -203 -14 0 -29 107 -264 180
                        -397 40 -71 73 -137 74 -145 1 -17 -48 -48 -231 -148 -59 -32 -136 -77 -171
                        -99 -34 -22 -64 -38 -66 -36 -8 11 40 283 75 428 75 312 92 353 353 868 22 43
                        36 54 36 28z m5172 -168 c52 -86 145 -268 168 -328 23 -57 23 -57 -67 -40 -28
                        6 -106 15 -174 21 -68 5 -139 13 -157 16 l-33 6 24 42 c14 22 59 110 102 194
                        43 83 83 152 89 152 6 0 28 -28 48 -63z m233 -528 c26 -85 95 -411 95 -447 0
                        -19 -1 -19 -62 -2 -55 15 -260 85 -310 105 -30 12 -21 36 48 130 83 114 169
                        243 185 278 7 15 14 26 16 24 2 -2 14 -42 28 -88z m-3355 -129 c0 -5 5 -10 11
                        -10 5 0 7 5 3 11 -5 8 10 10 52 5 33 -3 95 -9 138 -12 66 -6 76 -9 59 -18 -67
                        -36 -216 -200 -253 -278 l-27 -57 -12 52 c-7 29 -29 86 -49 127 -33 66 -43 77
                        -84 98 -44 21 -111 32 -124 20 -10 -10 25 -133 75 -267 54 -143 59 -160 38
                        -142 -23 19 -66 106 -108 218 -32 88 -48 117 -86 155 -46 47 -46 47 -22 56 87
                        33 389 66 389 42z m475 -59 c32 -11 60 -23 63 -25 2 -3 -10 -17 -27 -32 -36
                        -30 -140 -163 -163 -209 -9 -16 -23 -56 -32 -87 -9 -31 -20 -59 -25 -62 -13
                        -8 6 304 26 413 6 33 6 33 53 28 26 -3 73 -15 105 -26z m282 -106 c135 -48
                        218 -92 272 -143 l46 -44 -30 -15 c-68 -35 -132 -79 -167 -116 -45 -46 -50
                        -37 -8 13 33 38 37 72 19 146 -10 38 -15 44 -38 44 -69 0 -191 -88 -282 -203
                        -22 -27 -39 -46 -39 -43 0 11 40 168 72 284 19 66 37 112 45 112 6 0 56 -16
                        110 -35z m2723 -930 c-6 -88 -12 -166 -12 -172 -2 -21 -14 -15 -39 21 -13 19
                        -68 87 -122 150 -151 179 -169 203 -149 209 25 8 273 152 302 175 l25 20 3
                        -121 c1 -67 -2 -194 -8 -282z m-5846 316 c77 -43 167 -92 198 -108 32 -15 58
                        -30 58 -33 0 -9 -183 -265 -257 -360 -40 -51 -73 -98 -73 -105 0 -7 15 -16 33
                        -19 53 -11 361 -67 375 -68 17 -2 17 -3 -26 -61 -85 -115 -218 -314 -231 -345
                        -10 -24 -16 -30 -23 -20 -34 53 -157 520 -177 673 -6 44 -15 175 -21 290 -12
                        248 -12 235 -4 235 3 0 70 -36 148 -79z m2548 -61 c51 -15 93 -60 107 -115 16
                        -65 -6 -109 -68 -137 -73 -33 -76 -34 -76 -48 0 -12 72 -31 255 -64 41 -8 113
                        -24 159 -35 46 -12 85 -21 87 -21 11 0 2 -61 -10 -66 -8 -3 -85 12 -172 34
                        -88 22 -183 43 -211 47 l-53 7 0 -40 c0 -61 -37 -168 -72 -208 -49 -55 -101
                        -78 -183 -78 -119 -1 -209 55 -256 158 -39 85 -10 236 58 313 42 46 75 59 81
                        30 2 -10 -2 -16 -9 -15 -31 7 -41 -249 -13 -308 33 -69 151 -97 222 -54 38 23
                        71 88 72 140 0 33 -4 37 -58 65 -69 37 -121 80 -134 114 -15 39 -11 116 8 153
                        34 68 93 114 164 129 51 10 61 10 102 -1z m554 -410 c35 0 39 -23 16 -78 -11
                        -26 -32 -95 -46 -152 -14 -58 -36 -131 -47 -163 l-22 -58 -19 21 c-23 24 -21
                        41 22 225 15 66 31 142 35 168 6 36 11 47 22 43 8 -3 26 -6 39 -6z m2714 -82
                        c-1 -37 -82 -370 -107 -435 -9 -24 -2 -30 -146 145 -101 124 -150 196 -136
                        201 66 24 349 109 367 110 17 1 22 -4 22 -21z m-176 -645 c-85 -183 -136 -282
                        -183 -355 -26 -40 -52 -81 -58 -91 -8 -15 -11 -3 -16 55 -4 40 -27 150 -52
                        243 -24 94 -45 176 -45 183 0 7 15 12 40 12 22 0 75 7 117 15 100 20 181 32
                        215 34 l27 1 -45 -97z m-5291 6 c92 -2 167 -6 167 -8 0 -1 -12 -26 -26 -55
                        -15 -28 -60 -123 -100 -210 l-73 -159 -32 51 c-17 28 -36 49 -42 45 -6 -3 -7
                        -1 -3 5 4 7 -32 85 -79 175 -47 90 -85 166 -85 169 0 2 24 1 53 -3 29 -3 128
                        -8 220 -10z m2766 -291 l41 -63 -53 -25 c-65 -32 -233 -94 -307 -114 -114 -31
                        -205 -40 -272 -26 -60 11 -168 47 -168 55 0 2 9 29 20 59 l21 54 37 -10 c48
                        -13 139 -5 282 27 162 36 256 62 298 85 21 10 42 19 48 20 6 0 30 -28 53 -62z
                        m148 -149 c44 -28 63 -66 63 -130 0 -140 -153 -226 -518 -290 -87 -15 -227 -2
                        -397 36 -117 27 -146 42 -183 96 -27 39 -26 97 4 130 15 17 19 17 33 5 9 -8
                        49 -29 89 -46 169 -72 388 -59 615 36 83 35 188 106 221 149 15 19 30 35 33
                        35 3 0 21 -9 40 -21z m2039 -59 l53 0 -92 -118 c-51 -66 -108 -142 -127 -170
                        -19 -28 -39 -50 -45 -49 -7 3 -112 320 -115 346 0 2 61 1 137 -2 75 -4 160 -7
                        189 -7z" />
                            <path d="M4633 6963 c-15 -3 -20 -9 -16 -19 3 -9 -4 -28 -16 -44 -11 -16 -21
                        -35 -20 -42 0 -7 3 -6 7 4 6 15 10 15 32 3 19 -11 21 -14 7 -15 -21 0 -19 -37
                        14 -280 20 -147 26 -177 34 -168 7 7 23 94 46 243 10 72 22 142 25 158 l6 27
                        -68 0 c-60 0 -66 2 -49 14 10 7 27 11 37 8 10 -2 25 2 34 9 11 9 17 10 23 1 4
                        -7 11 -4 20 11 13 20 13 21 -1 9 -13 -10 -17 -10 -22 3 -3 9 -2 13 4 10 6 -3
                        10 -2 10 4 0 5 -4 13 -10 16 -5 3 -10 11 -10 17 0 6 10 3 22 -8 l21 -19 -17
                        26 c-22 35 -53 44 -113 32z" />
                        </g>
                    </svg>
                    <h2 class="m-0" style="font-size: 20px;">Quilombolas</h2>
                </div>
                <div class="github-button"  data-aos="fade-up" data-aos-duration="900">
                    <button class="btn btn-outline-secondary" @click="openGitHub">Git Hub <svg id="github" @click="openGitHub"
                            style="transform: scale(0.8); fill: #ffffff;" xmlns="http://www.w3.org/2000/svg" width="30"
                            height="30" viewBox="0 0 16 16">
                            <path
                                d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59c.4.07.55-.17.55-.38c0-.19-.01-.82-.01-1.49c-2.01.37-2.53-.49-2.69-.94c-.09-.23-.48-.94-.82-1.13c-.28-.15-.68-.52-.01-.53c.63-.01 1.08.58 1.23.82c.72 1.21 1.87.87 2.33.66c.07-.52.28-.87.51-1.07c-1.78-.2-3.64-.89-3.64-3.95c0-.87.31-1.59.82-2.15c-.08-.2-.36-1.02.08-2.12c0 0 .67-.21 2.2.82c.64-.18 1.32-.27 2-.27c.68 0 1.36.09 2 .27c1.53-1.04 2.2-.82 2.2-.82c.44 1.1.16 1.92.08 2.12c.51.56.82 1.27.82 2.15c0 3.07-1.87 3.75-3.65 3.95c.29.25.54.73.54 1.48c0 1.07-.01 1.93-.01 2.2c0 .21.15.46.55.38A8.012 8.012 0 0 0 16 8c0-4.42-3.58-8-8-8z" />
                        </svg>
                    </button>
                </div>
                <div class="copyrigth">
                    <p>© 2023 GRUPO QUILOMBOLAS</p>
                </div>
            </div>
        </div>
        <nav>
            <div class="options" id="optionOne" data-aos="fade-up">
                <router-link to="/" @click="goTo(0)">Início</router-link>
                <router-link to="/" @click="goTo(1)" class="subtitle">Surgimento</router-link>
                <router-link to="/" @click="goTo(2)" class="subtitle">Dificuldades</router-link>
            </div>
            <div class="options" id="optionTwo" data-aos="fade-up">
                <router-link to="/lugares" @click="goTo(0)">Lugares</router-link>
                <router-link to="/lugares" @click="goTo(1)" class="subtitle">Como se espalharam</router-link>
                <router-link to="/lugares" @click="goTo(2)" class="subtitle">Localizações</router-link>
                <router-link to="/lugares" @click="goTo(3)" class="subtitle">Palmares</router-link>
                <router-link to="/lugares" @click="goTo(4)" class="subtitle">Conheça outros</router-link>
            </div>
            <div class="options" id="optionThree" data-aos="fade-up">
                <router-link to="/producao" @click="goTo(0)">Produção</router-link>
                <router-link to="/producao" @click="goTo(1)" class="subtitle">Produção Predominante</router-link>
                <router-link to="/producao" @click="goTo(2)" class="subtitle">Agricultura Familiar</router-link>
                <router-link to="/producao" @click="goTo(5)" class="subtitle">Artesanato</router-link>
            </div>
            <div class="options" id="optionFour" data-aos="fade-up">
                <router-link to="/cultura" @click="goTo(0)">Cultura</router-link>
                <router-link to="/cultura" @click="goTo(0.8)" class="subtitle">Movimentos Sociais</router-link>
                <router-link to="/cultura" @click="goTo(1.6)" class="subtitle">Culinária</router-link>
                <router-link to="/cultura" @click="goTo(3.1)" class="subtitle">Danças e Religião</router-link>
            </div>
            <div class="options" id="optionFour" data-aos="fade-up">
                <router-link to="/sobre" @click="goTo(0)">Sobre</router-link>
                <router-link to="/sobre" @click="goTo(1)" class="subtitle">Motivações</router-link>
                <router-link to="/sobre" @click="goTo(1.8)" class="subtitle">Premissas</router-link>
                <router-link to="/sobre" @click="goTo(4.2)" class="subtitle">Ferramentas</router-link>
                <router-link to="/sobre" @click="goTo(5.2)" class="subtitle">Feedback</router-link>
                <router-link to="/sobre" @click="goTo(6.2)" class="subtitle">Integrantes</router-link>
            </div>
        </nav>
    </footer>
</template>

<script>

export default {
    methods: {
        goTo(int) {
            window.scroll({ top: innerHeight * int, behavior: "smooth" })
        },
        openGitHub() {
            window.open("https://github.com/K1Melo/pjct-quilombolas");
        },
    }
}

</script>

<style lang="less" scoped>
footer {
    background-image: url(../assets/footer-background.webp);
    background-size: cover;
    background-position: center;
    padding-top: 2%;
    padding-bottom: 4%;
    background-color: rgb(0, 0, 0);
    display: flex;
    overflow: hidden;
}

.us {
    width: 30%;
    display: flex;
    justify-content: center;
}

.title-logo-footer {
    display: flex;
    align-items: flex-start;
    flex-direction: column;

    h2 {
        font-weight: 100;
        color: rgb(255, 255, 255);
    }
}

.logo {
    display: flex;
    align-items: center;
}



nav {
    width: 70%;
    display: flex;
    justify-content: space-evenly;
    align-items: flex-start;

    a {
        margin-bottom: 10px;
        color: #ffffff;
        text-decoration: none;
        font-size: 14px;
    }
}

.options {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;

    margin-bottom: 50px;
}

.subtitle {
    color: #afafaf;
}

.github-button {
    margin-top: 5%;
    display: flex;
    align-items: center;
    justify-content: center;
}


.title-logo-footer {
    svg {
        fill: white;
    }
}

.copyrigth {
    margin-top: 10%;
    color: #ffffffdb;
    font-weight: 100;
}

@media only screen and (max-width: 1000px) {
    footer {
        flex-direction: column-reverse;
        padding-top: 10%;
    }

    .us {
        width: 50%;
        display: flex;
        justify-content: center;
    }

    nav {
        width: 100%;
        margin-bottom: 30px;

        a {
            margin-bottom: 10px;
            color: #ffffff;
            text-decoration: none;
        }
    }
}

@media only screen and (max-width: 800px) {
    nav {
        flex-direction: column;
        align-items: center;
    }

    .options {
        width: 40%;
    }

    .us {
        width: 100%;
    }
}
</style>